import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FlyingIconService {
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  flyToCart(startElem: HTMLElement, endElem: HTMLElement): void {
    const clone = startElem.cloneNode(true) as HTMLElement;
    const body = document.body;

    const startRect = startElem.getBoundingClientRect();
    const endRect = endElem.getBoundingClientRect();

    this.renderer.setStyle(clone, 'position', 'fixed');
    this.renderer.setStyle(clone, 'top', `${startRect.top}px`);
    this.renderer.setStyle(clone, 'left', `${startRect.left}px`);
    this.renderer.setStyle(clone, 'width', `${startRect.width}px`);
    this.renderer.setStyle(clone, 'height', `${startRect.height}px`);
    this.renderer.setStyle(clone, 'transition', 'transform 0.4s linear');
    this.renderer.setStyle(clone, 'z-index', '1000');
    this.renderer.setStyle(clone, 'pointer-events', 'none'); // Чтобы клон не реагировал на события

    this.renderer.appendChild(body, clone);

    const translateX = (endRect.left + endRect.width / 2) - (startRect.left + startRect.width / 2);
    const translateY = (endRect.top + endRect.height / 2) - (startRect.top + startRect.height / 2);

    // Запускаем анимацию перемещения
    requestAnimationFrame(() => {
      this.renderer.setStyle(clone, 'transform', `translate(${translateX}px, ${translateY}px)`);
    });

    // Ожидаем завершения анимации (0.75s) и удаляем клон
    setTimeout(() => {
      this.renderer.removeChild(body, clone);
    }, 400);
  }
}
